import { useQuery } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  GroupSubscriptionRecipientsParams,
  getGroupSubscriptionRecipients,
} from '../utils/backend-api/groupSubscription';

export default function useGroupSubscriptionRecipients(params: GroupSubscriptionRecipientsParams) {
  const { data, isLoading } = useQuery([GROUP_SUBSCRIPTION_KEY, params.type], () =>
    getGroupSubscriptionRecipients(params)
  );
  return { data, isLoading };
}
